<template lang="html">
  <!-- tipPopupVisible -->
  <div class="container" :class="{'isPop':timePopupVisible}">
    <div class="header">
      <!-- <span class="okrs-btn" @click="pushOKRs">OKR</span> -->
      <img src="../assets/img/homepagebg.png" alt="">
      <p class="time">{{begin_time}}-{{end_time}}</p>
       <!-- <p class="group">{{getCurrentGroup()}}</p> -->
      <!--日期选择按钮-->
      <i class="icon iconfont icon-rili" @click="showTimePicker"></i>
       <!-- <i class="icon iconfont icon-rili" @click="filter"></i> -->
      <!-- <p class="money">回款比例</p>
      <p class="num"  @click="tipPopupVisible = true" >{{type == 1 ? data.m_b_per : data.y_a_per }}%</p> -->

      <div class="caseleft case">
        <p style="color:#fff;" @click="toDrill(1,1)">
          ¥{{  data.m_q_money == undefined ? '' : (data.m_q_money/10000).toFixed(2) }}
          <span>(万)</span>
        </p>
        <p>已签约 {{data.m_q_count}}个</p>
      </div>

      <span class="line"></span>

      <div class="casecenter case">
        <p style="color:#fff;" @click="toDrill(2,1)">
          ¥{{ data.m_b_money == undefined ? '' : (data.m_b_money/10000).toFixed(2) }}
          <span>(万)</span>
        </p>
        <p>已回款</p>
      </div>
      <span class="line1"></span>

      <div class="caseright case">
        <p style="color:#fff;" @click="toDrill(6,1)">
          ¥{{ data.n_y_money == undefined ? '' : (data.n_y_money/10000).toFixed(2) }}
          <span>(万)</span>
        </p>
        <p>已开票</p>
      </div>

      <div class="money-wrapper">

          <div class="item" @click="toDrill(3,1)">
            <p class="price"  >
               <span class="symbol">¥</span>
               {{ data.m_j_money == undefined ? '' : (data.m_j_money/10000).toFixed(2) }}<span class="unit">(万)</span>
            </p>
            <p class="price-name">已交付 <span class="num">{{ data.m_j_count == undefined ? '' : data.m_j_count}}个</span> </p>
          </div>

          <div class="item" @click="toDrill(4,2)">
            <p class="price">
              <span class="symbol">¥</span>
              {{ data.h_i_money == undefined ? '' : (data.h_i_money/10000).toFixed(2) }}<span class="unit">(万)</span>
            </p>
            <p class="price-name">已开发票待回款 </p>
          </div>

          <div class="item" @click="toDrill(5,2)">
            <p class="price">
              <span class="symbol">¥</span>
              {{ data.w_i_money == undefined ? '' : (data.w_i_money/10000).toFixed(2) }}<span class="unit">(万)</span>
            </p>
            <p class="price-name">未开发票待回款 </p>
          </div>

        </div>
    </div>

    <!-- 时间选择 -->
    <mt-popup v-model="timePopupVisible" position="bottom"  popup-transition="popup-fade" style="width:100%">
      <mt-picker :slots="slots" @change="onDateChange" valueKey="name"></mt-picker>
      <div class="footer">
        <span @click="timePopupVisible = false">取消</span>
        <span style="color:#5482D2;" @click="timeConfirm">确认</span>
      </div>
    </mt-popup>


    <div class="rank">
<!--首页回款排行-->
        <p class="test">
          {{begin_time}}-{{end_time}}回款排行
          <span @click="toRanking">更多 ></span>
        </p>
<!--如果销售排名查询不到，则显示公共组件，显示暂无数据-->
        <div class="tip"  v-if="!saleList.length">
          <img src="../assets/img/nodata_s.png" alt="">
          <!-- <p>{{begin_time}}-{{end_time}} 暂无排名</p> -->
        </div>
      <!--首页回款排名，默认显示3条数据，点击toDetail（更多按钮）跳转进入详情-->
        <div class="one" v-for="(item,index) in saleList" v-if="item.sort <= 3" @click="toDetail(item)">
          <!--../assets/img/1.png,静态资源文件，显示排名图片1-3名小图-->
          <img src="../assets/img/1.png" alt="" class="bg1" v-if="item.sort == 1">
          <img src="../assets/img/2.png" alt="" class="bg1" v-if="item.sort == 2">
          <img src="../assets/img/3.png" alt="" class="bg1" v-if="item.sort == 3">
          <!--首页回款排名,获取排名人物的头像，并展示-->
          <img :src='getSrc(item, index)' alt="" class="people">
          <!--人物名称-->
          <p class="name">{{item.name}}</p>
          <!-- 销售金额-->
          <p class="money1">¥{{(item.bmoney/10000).toFixed(2)}}(万)</p>
        </div>
    </div>
    <!--新增区域回款排名-->
    <div  style="background:white">
      <p class="test1" >
        {{begin_time}}-{{end_time}}小组回款排行(万)
        <span @click="toSaleRank('three')">更多 ></span>
      </p>
      <div class="percent1">
        <!--区域回款排名情况折线图-->
        <IEcharts :option="itemAverageValueBar"></IEcharts>
      </div>
    </div>
    <div  style="background:white">
      <p class="test1" >
        {{begin_time}}-{{end_time}}区域回款排行(万)
        <span @click="toSaleRank('two')">更多 ></span>
      </p>
      <div class="percent1">
        <!--区域回款排名情况折线图-->
        <IEcharts :option="averageValueBar2"></IEcharts>
      </div>
    </div>

    <div class="percent1" >
      <p class="test">
        各制作部门{{begin_time}}-{{end_time}}交付／回款情况(万)
      </p>
      <!--交付／回款情况折线图-->
      <IEcharts :option="bar"  ></IEcharts>
    </div>
    <div class="zhezhao" v-if="isFilter" @click="cancel"></div>

    <!--筛选-->
    <div class="selbox" v-if="isFilter">
      <p>筛选</p>

      <!-- <p class="content">
        时间
      </p> -->

      <ul class="listtime">
        <mt-picker :slots="slots" @change="onDateChange" valueKey="name" class="inner-picker" :visibleItemCount="3"></mt-picker>
      </ul>

      <p  class="content">
        事业部
      </p>
      <ul  class="listtime">
        <li :class="{'true': item.id== c_group}" v-for="(item,index) in financeGroup" @click="onGroupChange(item.id)" >{{item.name}}</li>
      </ul>
       <!-- <ul  class="listtime">
        <li :class="{'true': item.id == c_region[0]}" v-for="(item,index) in region_list" @click="onRegionChang(item.id)" :key="item.id" >{{item.name}}</li>
      </ul> -->

      <p class="btnyes" @click="confirmFilter">确定</p>
    </div>

  </div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/lite.js'//引入图表插件
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'//
import 'echarts/lib/chart/pie'//饼图
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/line'//折线图
import 'echarts/lib/component/title'//标题
import nodata from './public/nodata'//暂无数据组件2
import slotsList from '../assets/js/slotsList'//公共日期js
import { Popup, Picker } from 'mint-ui'//日期选择
import Vue from 'vue'
import { getMonthRanges } from '../assets/js/date'

import dateChange from '../mixins/dateChange.js'
import regionChange from '../mixins/regionChange.js'
import config from '../fetch/config'
Vue.component(Popup.name, Popup)//引入图表组件
Vue.component(Picker.name, Picker)//引入时间选择组件


export default {
  mixins: [dateChange, regionChange],
  data() {
    return {
      data: [], //5个主要数据
      saleList: [],//销售列表
      numberList: [],
      slots: null, //日期选择
      timePopupVisible: false, //日期选择弹窗,默认不显示，点击菜单将其改为true，显示弹框
      // tipPopupVisible:false,

      region: {
        1: '深圳',
        3: '上海',
        4: '北京',
        5: '成都',
        6: '海南',
        7: '渠道'
      }, //地区数据
      arr: [],
      begin_time: '', //过滤起始时间
      end_time: '', //过滤结束时间
      isFilter: false,
      group: '',
      averageValueBar2: {
        //区域回款排名
        legend: {
          width: '80%',
          bottom: '3%',
          icon: 'circle',
          itemGap: 2,
          textStyle: {
            fontSize: 10,
            color: '#333',
          }
        },
        grid: {
          left: '3%',
          right: '18%',
          bottom: '8%',
          top: '-2%',// 配置图表距离顶部的间隙
          containLabel: true
        },
        tooltip: {
          show: "true",
          trigger: 'axis',//x轴显示
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'value',
          axisTick: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#666',
            }
          },
          splitLine: {
            show: false
          },
        },
        yAxis: {
          type: 'category',
          axisTick: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#666',
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              // color:'#EEEFF0',


            },

          },

          data: []
        },
        series: [{
          type: 'bar',
          barWidth: '26%',
          label: {
            normal: {
              show: true,
              color: '#666',//字体颜色
              position: 'right',
              formatter: function (params) {
                if (params.value) {
                  return Number(params.value).toFixed(2) + '万'
                }
              }
            }
          },
          itemStyle: {
            normal: {
              //callback,//设定每一bar颜色,配置项color顶axis一组bars颜色
              color: function (params) {
                //var myColor = ['#86E687','#6DB0FB','#D185FF','#FFA761','#AE35A']
                var myColor = ['#6b2cfa', '#EDCB4B', '#D185FF', '#6DB0FB', '#8795ed', '#4BE635']
                var num = myColor.length;
                return myColor[params.dataIndex]

              },
              barBorderRadius: [0, 18, 18, 0],

            }
          },
          data: []
        }]
      }, //各制作部门人均产值对比 //各制作部门人均产值对比
      //各制作部门人均产值对比 //各制作部门人均产值对比
      itemAverageValueBar: {
        //区域回款排名
        legend: {
          width: '80%',
          bottom: '3%',
          icon: 'circle',
          itemGap: 2,
          textStyle: {
            fontSize: 10,
            color: '#333',
          }
        },
        grid: {
          left: '3%',
          right: '18%',
          bottom: '8%',
          top: '-2%',// 配置图表距离顶部的间隙
          containLabel: true
        },
        tooltip: {
          show: "true",
          trigger: 'axis',//x轴显示
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'value',
          axisTick: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#666',
            }
          },
          splitLine: {
            show: false
          },
        },
        yAxis: {
          type: 'category',
          axisTick: { show: false },
          //  axisLabel: {
          //   interval: 0,
          //   rotate: 60
          // },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#666',
            }
          },
          splitLine: {
            show: false,
            lineStyle: {},

          },

          data: []
        },
        series: [{
          type: 'bar',
          barWidth: '26%',
          label: {
            normal: {
              show: true,
              color: '#666',//字体颜色
              position: 'right',
              formatter: function (params) {
                if (params.value) {
                  return Number(params.value).toFixed(2) + '万'
                }
              }
            }
          },
          itemStyle: {
            normal: {
              //callback,//设定每一bar颜色,配置项color顶axis一组bars颜色
              color: function (params) {
                //var myColor = ['#86E687','#6DB0FB','#D185FF','#FFA761','#AE35A']
                var myColor = ['#6b2cfa', '#EDCB4B', '#D185FF', '#6DB0FB', '#8795ed', '#4BE635']
                var num = myColor.length;
                return myColor[params.dataIndex]

              },
              barBorderRadius: [0, 18, 18, 0],

            }
          },
          data: []
        }]
      },


      bar: {  //各制作部门交付／回款情况echarts数据
        color: ['#FFA761', '#6DB0FB'],
        legend: {
          width: '70%',
          bottom: '3%',
          icon: 'circle',
          data: ['交付情况', '回款情况'],
          itemGap: 40,
          textStyle: {
            fontSize: 12,
            color: '#666',
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '4%',
          right: '4%',
          top: '20%',
          bottom: '14%',
          containLabel: true
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            interval: 0,
            rotate: 40,
            textStyle: {
              color: '#475669',
              fontSize: 8,
            }
          },
          show: true,
          barGap: 0,
          padding: 0,
          barMaxWidth: 1,
          type: 'category',
          data: ['制作一部', '制作二部', '制作三部', '制作四部', '制作五部'],
          fontSize: 6,
          scale: true,
          lineStyle: 2,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#666',
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            barGap: 1,
            padding: 0,
            axisLabel: {
              //formatter: '{value}W'
              formatter: '{value}'
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#666',
              }
            },
            minInterval: 1
            // data: ['1', '2', '3', '4', '5', '6','7','8（个）'],
          }
        ],
        series: [
          {
            name: '交付情况',
            type: 'bar',
            barGap: '100%',
            barWidth: '16%',
            data: [],
            itemStyle: {
              normal: {
                show: true,
                barBorderRadius: [20, 20, 0, 0],
                borderWidth: 0,
              }
            },
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#666'
                },
              }
            },
          },
          {
            name: '回款情况',
            type: 'bar',
            barWidth: '16%',
            data: [],
            itemStyle: {
              normal: {
                show: true,
                barBorderRadius: [20, 20, 0, 0],
                borderWidth: 0,
              }
            },
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#666'
                },
              }
            },
          },
        ]
      },

      valueBar: {
        color: ['#6DB0FB'],
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '4%',
          right: '4%',
          top: '30%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              // alignWithLabel: true
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: '#475669',
                fontSize: 8,
              }
            },
            axisLine: {
              lineStyle: {
                color: '#E4E4E4',
              }
            },
          }
        ],
        yAxis: [
          {
            name: '产值 \n（万元）',
            type: 'value',
            barGap: 1,
            padding: 0,
            axisLabel: {
              //formatter: '{value}W'
              formatter: '{value}'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#E4E4E4',
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#475669',
                fontSize: 10,
              }
            },
            axisLine: {
              lineStyle: {
                color: '#E4E4E4',
              }
            },
            nameTextStyle: {
              color: '#666',
              align: 'center',
              fontSize: 10,
            },
            minInterval: 1
            // data: ['1', '2', '3', '4', '5', '6','7','8（个）'],
          }
        ],
        series: [
          {
            name: '产值',
            type: 'bar',
            barGap: '100%',
            barWidth: '20%',
            data: [],
            itemStyle: {
              normal: {
                show: true,
                barBorderRadius: [20, 20, 0, 0],
                borderWidth: 0,
              }
            },
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#666'
                },
              }
            },
          },
        ]
      },  //各制作部门产值占比 echarts数据

      averageValueBar: {
        legend: {
          width: '100%',
          bottom: '3%',
          icon: 'circle',
          data: ['制作一部', '制作二部', '制作三部', '制作四部', '制作五部'],
          itemGap: 2,
          textStyle: {
            fontSize: 10,
            color: '#333',
          }
        },
        grid: {
          left: '1%',
          right: '10%',
          bottom: '14%',
          containLabel: true
        },
        tooltip: {
          show: "true",
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'value',
          axisTick: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#666',
            }
          },
          splitLine: {
            show: false
          },
        },
        yAxis: {
          type: 'category',
          axisTick: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#666',
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#EEEFF0',
            },
          },
          data: ['制作一部', '制作二部', '制作三部', '制作四部', '制作五部']
        },
        series: [{
          type: 'bar',
          barWidth: '26%',
          label: {
            normal: {
              show: true,
              position: 'right',
              formatter: function (params) {
                if (params.value) {
                  //console.log(Number(params.value).toFixed(2))
                  return Number(params.value).toFixed(2)

                }
              }
            }
          },
          itemStyle: {
            normal: {
              // callback,设定每一bar颜色,配置项color顶axis一组bars颜色
              color: function (params) {
                var myColor = ['#FFA761', '#D185FF', '#6DB0FB', '#86E687']
                var num = myColor.length;
                return myColor[params.dataIndex]
              },
              barBorderRadius: [0, 18, 18, 0],
            }
          },
          data: []
        }]
      }, //各制作部门人均产值对比 //各制作部门人均产值对比
    }
  },
  components: {
    IEcharts,
    nodata,
  },
  methods: {
    pushOKRs() {
      this.$http.getMyData().then(res => {
        if (res.errCode == 0) {
          window.location.href = `${config.okrUrl}${res.data.id}`
        } else {
          this.$notice.tip('获取用户id失败,请联系管理员~')
        }
      })
    },
    confirmFilter() {
      //确定
      this.begin_time = this.c_begin_time
      this.end_time = this.c_end_time
      let data = {
        begin_time: this.begin_time,
        end_time: this.end_time,
        finance_group: this.c_group,//新增部门筛选
      }
      window.localStorage.setItem('finance_group', this.c_group)

      this.getData(data)
      this.isFilter = false
    },
    filter() { //显示过滤
      this.slots = slotsList.Monthslots(this.begin_time, this.end_time)
      this.isFilter = true
      // this.$emit('inFilter')
    },
    cancel() {
      this.isFilter = false
    },
    showTimePicker() {  //显示时间选择弹窗
      this.timePopupVisible = true
    },
    // 新排名
    toRanking() {
      this.$router.push({ name: 'Ranking', query: { begin_time: this.begin_time, end_time: this.end_time } })
    },
    toSaleRank(number) {
      let data = {
        begin_time: this.begin_time,
        end_time: this.end_time,
      }
      window.localStorage.setItem('drillData', JSON.stringify(data))
      window.localStorage.setItem('numberlData', JSON.stringify(number))
      this.$router.push({ name: 'backrank' })
    }, //查看销售详情
    getSrc(item, index) { //获取图片
      let src = ''
      if (item.avatar_path == null || item.avatar_path == '') {
        let num = Math.floor(Math.random() * 3 + 1)
        src = require(`../assets/img/sale_avatar${num}.png`)
      } else {
        src = item.avatar_path
      }
      return src
    },

    timeConfirm() { //时间确定
      this.begin_time = this.c_begin_time
      this.end_time = this.c_end_time
      let data = {
        begin_time: this.begin_time,
        end_time: this.end_time
      }
      this.getData(data)
      this.timePopupVisible = false
    }, //确定时间

    toDrill(type, types) { // 点击 =》 钻取页

      let data = {
        types: types,
        begin_time: this.begin_time,
        end_time: this.end_time,
        region: [0],
        item: [0],
      }
      data.types = types

      switch (type) {
        case 3:
          this.toDeliverDrill(data)
          break;
        case 4:
          this.toInvoiceReturnDrill(data)
          break;
        case 5:
          this.toNoInvoiceReturnDrill(data)
          break;
        default:
          this.toSignDrill(data, type)
          break;
      }
    },

    toSignDrill(data, type) { // 查看签约钻取详情
      data.type = type  // type:1 签约 2:回款
      data.origin = 1
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'bsdrill' })
    },


    toRegionBackDrill(data) {
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'armrdrill' })
    },

    toDeliverDrill(data) { //已交付金额
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'dmdrill' })
    },

    toInvoiceReturnDrill(data) { //已开发票待回款
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'irdrill' })
    },

    toNoInvoiceReturnDrill(data) { //未开发票待回款
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'nirdrill' })
    },

    findRegionID(name) { //查找地区id
      let region = this.region
      for (var key in region) {
        if (region[key] == name) {
          return key
        }
      }
    },

    getData(data) {
      this.$notice.loading()
      this.$http.getHomePageData(data).then(res => { //获取七个主要数据
        this.data = res.data
        window.localStorage.setItem('role', JSON.stringify(res.data.role))
        // console.log( window.localStorage.getItem('role'),'role')
      })
      let saleHttp = {
        begin_time: this.begin_time,
        end_time: this.end_time,
        finance_group: this.c_group,//部门筛选
        type: 'backMoney'
      }
      this.$http.getSaleSort(saleHttp).then(res => { //销售排名
        this.saleList = res.data.backs
      })
      this.$http.getHomePagePie(data).then(res => { //获取各区域签约金额占比与回款占比

        //区域回款排行
        this.averageValueBar2.series[0].data = res.data.b_list.reverse()//默认从低到高，反向排序
        this.averageValueBar2.yAxis.data = res.data.b_list.map(item => {
          return item.name
        })//地区
        console.log('this.averageValueBar2', this.averageValueBar2)
        this.$notice.loading(false)
      })
      this.$http.getItems(data).then(res => {
        if (res.data.b_list.length > 5) {//如果超过5个数据就只是显示5个数据
          this.itemAverageValueBar.series[0].data = (res.data.b_list.slice(0, 5)).reverse()
          let itemTemp = (res.data.b_list.slice(0, 5).map(item => {
            return item.name
          }))//地区
          this.itemAverageValueBar.yAxis.data = itemTemp.reverse()
        } else {//若没超过5个显示全部
          this.itemAverageValueBar.series[0].data = (res.data.b_list).reverse()
          let itemTemp1 = (res.data.b_list.map(item => {
            return item.name
          }))//地区
          this.itemAverageValueBar.yAxis.data = itemTemp1
        }

      })
      this.$http.getHomePageDelivery(data).then(res => { //获取各制作部门交付／回款情况，显示柱状图
        this.bar.xAxis.data = res.data.list.name
        this.bar.series[0].data = res.data.list.d_money//显示金额
        this.bar.series[1].data = res.data.list.b_money//制作部门
      })
      this.$http.getHomepageGroupValue(data).then(res => { //各制作部门产值占比
        this.valueBar.xAxis[0].data = res.data.group_id
        this.valueBar.series[0].data = res.data.value
        this.$notice.loading(false)
      })
      this.$http.getHomePageAVGValue(data).then(res => { //各制作部门人均产值对比
        this.averageValueBar.series[0].data = res.data

      })

    }, //获取数据


    toDetail(item) {  //获取销售详情
      let data = {
        id: item.uid,
        begin_time: this.begin_time,
        end_time: this.end_time,
        type: 3,
      }
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'backdetail' })
    },


  },
  created() {
    if (!window.localStorage.getItem('drillData')) {
      this.begin_time = getMonthRanges().begin_time
      this.end_time = getMonthRanges().end_time
      this.slots = slotsList.Monthslots()
    } else {
      let data = JSON.parse(window.localStorage.getItem('drillData'))
      this.begin_time = data.begin_time
      this.end_time = data.end_time
      this.slots = slotsList.Monthslots(this.begin_time, this.end_time)
    }
    console.log('this.c_begin_time', this.begin_time)
    console.log('this.c_end_time', this.end_time)
    this.getData({ begin_time: this.begin_time, end_time: this.end_time, finance_group: this.c_group })
    // this.getData({ begin_time: this.begin_time, end_time: this.end_time,group:this.c_group })
    this.departid = JSON.parse(window.localStorage.getItem('departmentId'))// 先获取departmentId，

  },

}
</script>

<style lang="css" scoped>
.container {
  width: 100%;
  background-color: #fafafa;
}
.okrs-btn {
  position: absolute;
  left: 22px;
  top: 20px;
  display: inline-block;
  width: 40px;
  height: 30px;
  line-height: 28px;
  font-family: HelveticaNeue;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  z-index: 9999;
  border: 1px solid #ffffff;
  border-radius: 6px;
  animation: heartBeat 1.5s ease-in-out infinite;
}
.container.isPop {
  height: 90vh;
  overflow: hidden;
}
.header {
  width: 100%;
  font-size: 0.375rem;
  height: 4.4375rem;
  position: relative;
  margin-bottom: 2.09375rem;
}
.header img {
  width: 100%;
  height: 100%;
}
.line {
  border: 1px solid;
}
.time {
  color: #fff;
  position: absolute;
  top: 0.6875rem;
  line-height: 0.5625rem;
  text-align: center;
  width: 100%;
  font-size: 0.4375rem;
}
.group {
  color: #fff;
  position: absolute;
  top: 1.5rem;
  line-height: 0.5625rem;
  text-align: center;
  width: 100%;
  font-size: 0.4375rem;
}
i.icon {
  /*width: 0.5625rem;*/
  height: 0.5625rem;
  font-size: 0.5625rem;
  color: #fff;
  position: absolute;
  top: 0.55rem;
  right: 0.625rem;
}
.money {
  position: absolute;
  color: #a4c7ff;
  width: 100%;
  text-align: center;
  top: 2.1875rem;
  font-size: 0.4375rem;
}

.caseleft,
.caseright,
.casecenter {
  position: absolute;
  top: 2.4375rem;
  /*left: 0;*/
  width: 30%;
  text-align: center;
}
.caseleft {
  left: 2%;
}
.caseright {
  right: 2%;
  width: 30%;
}
.casecenter {
  left: 35%;
}
.case p:nth-child(1) {
  /*font-size: 0.6875rem;*/
  font-size: 0.45rem;
}
.case p span {
  /*font-size: 0.375rem;*/
  font-size: 0.3rem;
}
.case p:nth-child(2) {
  font-size: 0.3375rem;
  color: #a4c7ff;
}

.money-wrapper {
  width: 96%;
  margin: auto;
  color: #000;
  height: 2.125rem;
  border: 0;
  box-shadow: 0 0 0.3125rem #979797;
  border-radius: 0.25rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 4.25rem;
  background: #fff;
  display: flex;
}
.money-wrapper .item {
  flex: 1;
  padding: 0.36875rem 0;
  text-align: center;
}
.item .price {
  color: #5482d2;
  font-size: 0.5rem;
  padding-bottom: 0.1875rem;
}
.item .price .symbol {
  font-size: 0.1875rem;
}
.item .price .unit {
  font-size: 0.3125rem;
}
.price-name {
  color: #666666;
}
.price-name .num {
  color: rgba(84, 130, 210, 0.6);
}

.wan {
  font-size: 0.375rem;
}
.line {
  border: 1px solid #a4c7ff;
  position: absolute;
  top: 60%;
  left: 33%;
  height: 0.9rem;
  right: 0;
  width: 0;
}
.line1 {
  border: 1px solid #a4c7ff;
  position: absolute;
  top: 60%;
  left: 66%;
  height: 0.9rem;
  right: 0;
  width: 0;
}
.rank {
  color: #000;
  height: 5.84375rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.1875rem;
  font-size: 0;
}
.percent1 {
  color: #000;
  height: 8.84375rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.1875rem;
}
.percent2 {
  color: #000;
  height: 8rem;
  position: relative;
  top: 0rem;
  width: 100%;
  background: #fff;
  margin-bottom: 0.103rem;
}
.percent1.ex {
  height: 9.04375rem;
}
/*.percent2{
                  color: #000;
                  height: 7.24375rem;
                  position: relative;
                  width: 100%;
                  background: #fff;
                  margin-bottom: 0.1875rem;
                }
                .percent3{
                  color: #000;
                  height: 6.84375rem;
                  position: relative;
                  width: 100%;
                  background: #fff;
                  margin-bottom: 0.1875rem;
                }
                .percent4{
                  color: #000;
                  height: 6.84375rem;
                  position: relative;
                  width: 100%;
                  background: #fff;
                  margin-bottom: 0.1875rem;
                }*/
.test {
  border-left: 0.0625rem solid #5483d2;
  width: 100%;
  position: absolute;
  right: 0;
  top: 0.34375rem;
  font-size: 0.375rem;
  color: #333333;
  font-family: PingFangSC-Regular;
  padding-left: 2%;
  font-weight: 500;
  line-height: 1.6;
}
.test span {
  position: absolute;
  right: 5%;
  font-family: PingFangSC-Regular;
  color: #5482d2;
  font-size: 0.375rem;
}
.test1 {
  border-left: 0.0625rem solid #5483d2;
  width: 100%;
  right: 0;
  top: 0.34375rem;
  font-size: 0.375rem;
  color: #333333;
  font-family: PingFangSC-Regular;
  padding-left: 2%;
  font-weight: 500;
  line-height: 1.6;
  position: relative;
  height: 0.85rem;
}
.test1 span {
  position: absolute;
  right: 5%;
  font-family: PingFangSC-Regular;
  color: #5482d2;
  font-size: 0.375rem;
}
.one,
.two,
.three {
  height: 4rem;
  border: 1px solid #cfe1ff;
  display: inline-block;
  width: 29.56%;
  margin-left: 2.5%;
  margin-top: 13.21%;
  position: relative;
}
.tip {
  margin-top: 1.875rem;
  font-size: 0.375rem;
  display: inline-block;
  width: 100%;
  text-align: center;
  color: #5482d2;
}
.tip img {
  width: 120px;
}
.bg1 {
  position: absolute;
  left: 50%;
  top: 0;
  width: 0.625rem;
  margin-left: -0.3125rem;
  height: 0.78125rem;
}
.people {
  position: absolute;
  width: 2.1875rem;
  height: 2.1875rem;
  left: 50%;
  top: 22.63%;
  /*margin-left: -0.75rem;*/
  transform: translateX(-50%);
}
.name {
  font-size: 0.28125rem;
  position: absolute;
  bottom: 10%;
  left: 50%;
  width: 1.5625rem;
  margin-left: -0.78125rem;
  text-align: center;
}
.money1 {
  font-size: 0.28125rem;
  color: #5482d2;
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 1.5625rem;
  margin-left: -0.78125rem;
  text-align: center;
}
.footer {
  width: 100%;
  height: 1.25rem;
  font-size: 0;
}
.footer span {
  width: 50%;
  height: 1.125rem;
  font-size: 0.5rem;
  line-height: 1.25rem;
  display: inline-block;
  text-align: center;
}
.tip-box {
  width: 100%;
  height: 2.65rem;
  border-radius: 0.3125rem;
}
.tip-box p {
  margin: 0.3125rem;
  border-left: 0.09375rem solid #5483d2;
  font-size: 0.375rem;
}
.tip-box span.word {
  display: block;
  margin-left: 0.625rem;
  margin-top: 0.3125rem;
}
/*.mint-popup{
                  border-radius: 0.3125rem;
                }*/
.legend-wrapper {
  position: absolute;
  bottom: 1%;

  /*display: inline-block;*/
  width: 84%;
  margin: 0 8%;
}
.legend-row {
  display: flex;
}
.legend-item {
  flex: 1;
  text-align: center;
  display: flex;
  align-items: center;
  font-size: 0.3125rem;
  color: #333;
}
.legend-icon {
  width: 0.375rem;
  height: 0.375rem;
  background-color: #ffa761;
  display: inline-block;
  border-radius: 50%;
  margin: 0.125rem;
}
.legend-icon.d-two {
  background-color: #d185ff;
}
.legend-icon.d-three {
  background-color: #6db0fb;
}
.legend-icon.d-four {
  background-color: #86e687;
}
.legend-icon.d-five {
  background-color: #fae35a;
}

@keyframes heartBeat {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  14% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  28% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  42% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue